/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackChartDataViewModel } from "../types/FeedbackChartDataViewModel.ts";
import { feedbackChartPointViewModelSchema } from "./feedbackChartPointViewModelSchema.ts";

export const feedbackChartDataViewModelSchema = z.object({
  feedbackId: z.optional(z.number().int()),
  chartType: z.string().nullish(),
  type: z.optional(z.number().int()),
  typeText: z.string().nullish(),
  points: z.array(z.lazy(() => feedbackChartPointViewModelSchema)).nullish(),
}) as unknown as ToZod<FeedbackChartDataViewModel>;
